import service from "@/utils/request";

/**
 * إرجاع جميع الفرق
 */
export const getAllTeams = async (page = 1) => {
    try {
        const response = await service.get(`/teams?page=${page}`);
        return response;
    } catch (e) {
        console.error("Failed to fetch Teams:", e);
    }
};

/**
 * إرجاع فريق معين
 */
export const getTeamById = async (id) => {
    try {
        const response = await service.get(`/teams/${id}`);
        return response;
    } catch (e) {
        console.error("Failed to fetch Team:", e);
    }
};

/**
 * إضافة فريق جديد
 */
export const addTeam = async (team) => {
    try {
        const response = await service.post('/teams', team);
        return response;
    } catch (e) {
        console.error("Failed to add Team:", e);
    }
};

/**
 * تحديث بيانات فريق
 */
export const updateTeam = async (id, team) => {
    try {
        const response = await service.put(`/teams/${id}`, team);
        return response;
    } catch (e) {
        console.error("Failed to update Team:", e);
    }
};

/**
 * حذف فريق
 */
export const deleteTeam = async (id) => {
    try {
        const response = await service.delete(`/teams/${id}`);
        return response;
    } catch (e) {
        console.error("Failed to delete Team:", e);
    }
};

/**
 * تعيين مستخدم إلى فريق
 */
export const assignUserToTeam = async (data) => {
    try {
        const response = await service.post(`/teams/${data.team_id}/assign-user`, { user_id: data.user_id });
        return response;
    } catch (e) {
        console.error("Failed to assign User to Team:", e);
    }
};

/**
 * إرجاع أعضاء الفريق
 */
export const getTeamMembers = async (teamId) => {
    try {
        const response = await service.get(`/teams/${teamId}/members`);
        return response;
    } catch (e) {
        console.error("Failed to fetch Team Members:", e);
    }
};

/**
 * إزالة مستخدم من الفريق
 */
export const removeUserFromTeam = async (teamId, userId) => {
    try {
        const response = await service.delete(`/teams/${teamId}/remove-user`, { data: { user_id: userId } });
        return response;
    } catch (e) {
        console.error("Failed to remove User from Team:", e);
    }
};
